import Statut from "constants/Statut";

const SST_DEFAULT_STATUTS_FILTER: Array<Statut> = [Statut.EN_ATTENTE];

const STORE_MANAGER_DEFAULT_STATUTS_FILTER: Array<Statut> = [
  Statut.EN_PREPARATION,
  Statut.COMMANDE,
  Statut.EN_TRANSIT,
  Statut.PRET_EN_MAGASIN,
];

const commandesFiltersService = {
  SST_DEFAULT_STATUTS_FILTER,
  STORE_MANAGER_DEFAULT_STATUTS_FILTER,
};
export default commandesFiltersService;
